import { fetcher } from "@certn/api";
import {
  BasicButton,
  DangerButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  Text,
  showToast,
} from "@certn/cascadia-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { APIKeyWithNameAndID } from "./types";

interface Props {
  isOpen: boolean;
  apiKey: APIKeyWithNameAndID;
  onOpenChange(isOpen: boolean): void;
  onRevoked(): void;
}

export function RevokeAPIKeyModal({
  isOpen,
  onOpenChange,
  onRevoked,
  apiKey,
}: Props) {
  const { t } = useTranslation();

  const [isRevoking, setIsRevoking] = useState(false);
  const onRevoke = async () => {
    setIsRevoking(true);
    try {
      await fetcher.submit(
        `/api/internal/client-portal/public-api/api-keys/${apiKey.id}/revoke/`
      );
      showToast(t("API key revoked"), { type: "success" });
      onOpenChange(false);
      onRevoked();
    } catch (e) {
      console.error("Failed to revoke API key", e);
      showToast(t("Failed to revoke API key"), {
        type: "error",
      });
    }
    setIsRevoking(false);
  };

  return (
    <Modal
      testID="revoke-api-key-modal"
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <Dialog>
        <DialogHeader onClose={() => onOpenChange(false)}>
          {t("Revoke API key")}
        </DialogHeader>
        <DialogContent>
          <Text style="global/body-primary">
            {t(
              "Once revoked, this API key will be disabled and removed from this list."
            )}
          </Text>
        </DialogContent>
        <DialogFooter>
          <BasicButton onPress={() => onOpenChange(false)} testID="cancel">
            {t("Cancel")}
          </BasicButton>
          <DangerButton
            testID="revoke-api-key"
            isDisabled={isRevoking}
            onPress={onRevoke}
          >
            {t("Revoke key")}
          </DangerButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
